module.exports = __webpack_public_path__ + "img/icon-yahoo.8be443d8.svg";